import { render, staticRenderFns } from "./ElementContent.vue?vue&type=template&id=a7cc39b6"
import script from "./ElementContent.vue?vue&type=script&lang=js"
export * from "./ElementContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports